import { observable, flow, makeObservable } from "mobx";

import { EAIClient } from "Services/EAIClient";
import { appStore } from "../";

export interface Label {
    id: number
    label_group: LabelGroup
    name: string
    school_id?: string
    is_archived: boolean
}

export interface LabelGroup {
    id: number
    name: string
    ordering: number
    labels: Label[]
}

class LabelStore {

    @observable isProcessing = false;
    @observable labels: Label[] = [];
    @observable labelGroups: LabelGroup[] = [];
    @observable label: Label;

    client = new EAIClient();

    constructor() {
        makeObservable(this);
    }

    @flow
    *fetchLabels (): any {
        this.isProcessing = true;
        try {
            const labelsResp = yield this.client.fetchLabels();
            this.labels = labelsResp.data.data;

        } catch(e) {
            appStore.addError(e);
        } finally {
            this.isProcessing = false;
        }
    }

    @flow
    *fetchLabel (labelId: string): any {
        try {
            const resp = yield this.client.fetchLabel(labelId);
            this.label = resp.data.data;
        } catch(e) {
            appStore.addError(e);
        }
    }

    @flow
    *createLabel (label: {name: string, label_group: number}): any {
        this.isProcessing = true;
        try {
            const resp = yield this.client.createLabel(label);
            this.label = resp.data.data;
        } catch(e) {
            appStore.addError(e);
        } finally {
            this.isProcessing = false;
        }
    }

    @flow
    *updateLabel (id: number, label: Partial<Label>): any {
        this.isProcessing = true;
        try {
            yield this.client.updateLabel(id, label);
            this.isProcessing = false;
        } catch(e) {
            appStore.addError(e);
        } finally {
            this.isProcessing = false;
        }
    }

    @flow
    *deleteLabel (labelId: number): any {
        this.isProcessing = true;
        try {
            yield this.client.deleteLabel(labelId);
            this.isProcessing = false;
        } catch(e) {
            appStore.addError(e);
        } finally {
            this.isProcessing = false;
        }
    }

    @flow
    *fetchLabelGroups (): any {
        this.isProcessing = true;
        try {
            const groupResp = yield this.client.fetchLabels(true);
            this.labelGroups= groupResp.data.data;
        } catch(e) {
            appStore.addError(e);
        } finally {
            this.isProcessing = false;
        }
    }

    @flow
    *createLabelGroup(data: {name: string, order?: number}): any {
        this.isProcessing = true;
        try{
            yield this.client.createLabelGroup(data);
        } catch(e) {
            appStore.addError(e);
        } finally {
            this.isProcessing = false;
        }
    }

    @flow
    *updateLabelGroup(groupId: number, data: Partial<LabelGroup>): any {
        this.isProcessing = true;
        try{
            yield this.client.updateLabelGroup(groupId, data);
        } catch(e){
            appStore.addError(e);
        } finally {
            this.isProcessing = false;
        }
    }

    @flow
    *deleteLabelGroup(groupId: number): any {
        this.isProcessing = true;
        try {
            yield this.client.deleteLabelGroup(groupId);
        } catch(e) {
            appStore.addError(e);
        } finally {
            this.isProcessing = false;
        }
    }

}

export { LabelStore };